"use client";
import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";

import { AppRouterInstance, NavigateOptions } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { DynamicOptions, LoadableGeneratedOptions } from "next/dynamic";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Media, MediaAlbum, MediaSaveOptions } from "@capacitor-community/media";
import { Debug } from "./debug";
import { RefObject, useState } from "react";
import { AlertProps, TransitionType } from "@/components/layout/layoutType";
import { checkMobile, disableScroll, enableScroll } from "./checkMobile";
import { isAndroid, isIOS, isSafari } from "react-device-detect";
import { checkEmpty } from "./stringutil";
import { platform } from "os";
import { setTimeoutDelay } from "@/components/layout/list/defaultType";
// import { AlbumPermission } from "android-album-permission";

// import type { AlbumPermissionPlugin } from "../../plugins/android-album-permission/src/definitions";
// import { AlbumPermission } from "../../plugins/android-album-permission/src";

// declare global {
//   interface Window {
//     AlbumPermission?: AlbumPermissionPlugin;
//   }
// }

export const useSpaRouter = true;
const checkTime = 1000 * 60 * 60 * 12; //최소 12시간에 한번씩 갱신
let appCreateTime = new Date();
export const isNativePlatform = Capacitor.isNativePlatform(); // ? true : process.env.NEXT_PUBLIC_LOCAL ? true : false;
export const useLinkRouter = true; //process.env.NEXT_PUBLIC_LOCAL ? true : false;
export const appScheme = process.env.NEXT_PUBLIC_APP_SCHEME;
export const appAppleId = process.env.NEXT_PUBLIC_APP_APPLE_ID;
export const useAppleSignIn = !checkEmpty(process.env.NEXT_PUBLIC_APPLE_CLIENT_ID);
export const getPrefetch = () => {
  const prefetch = false;
  // const prefetch = isAndroid();
  return prefetch;
};
export const isAndroidRouter = () => {
  return useSpaRouter ? true : Capacitor.getPlatform() === "android";
  // return Capacitor.getPlatform() === "android";
};
export const checkAndroid = Capacitor.getPlatform() === "android";
export const checkSafari = isSafari || Capacitor.getPlatform() === "ios";
export const checkAndroidWeb = isAndroid && Capacitor.getPlatform() === "web";
export const checkIOSWeb = isIOS && Capacitor.getPlatform() === "web";
export const checkWeb = Capacitor.getPlatform() === "web";
export const dynamicOptions: DynamicOptions = {
  ssr: true,
  loading: () => <div></div>,
  // suspense: false, // Suspense 끔
};

export const getAppSystemBars = (): Record<string, any> | undefined => {
  if (localStorage) {
    const systemBars = localStorage.getItem("AppSystemBarsValues");
    if (systemBars) {
      return JSON.parse(systemBars) as Record<string, any>;
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
};

export const setAppSystemBars = (vars: Record<string, any> | undefined, init?: boolean) => {
  const systemBars = getAppSystemBars();
  const setVars = init ? systemBars : vars;
  const checkBars = init ? undefined : systemBars;
  // Debug("systemBars", systemBars ? JSON.stringify(systemBars) : "");
  // Debug("checkBars", checkBars ? JSON.stringify(checkBars) : "");
  let changed = false;
  if (setVars) {
    Object.entries(setVars).forEach(([key, value]) => {
      if (!checkBars || String(value) !== checkBars[key]) {
        changed = true;
        document.documentElement.style.setProperty(key, String(value));
      }
    });
  }
  if (!init && !changed) {
    const setVarsLen = setVars ? Object.entries(setVars).length : 0;
    const checkVarsLen = checkBars ? Object.entries(checkBars).length : 0;
    if (setVarsLen !== checkVarsLen) {
      changed = true;
    }
  }
  if (!init && changed) {
    if (vars) {
      localStorage.setItem("AppSystemBarsValues", JSON.stringify(vars));
      Debug("save", JSON.stringify(vars));
    } else {
      localStorage.removeItem("AppSystemBarsValues");
    }
  }
};
export const appRouterPush = (
  router: AppRouterInstance,
  url: string,
  options?:
    | (NavigateOptions & {
        locale?: string | undefined;
      })
    | undefined,
  force?: boolean,
) => {
  if (isAndroidRouter()) {
    const locale = options?.locale;
    const path = (locale ? "/" + locale + "/" : "") + url;
    if (useSpaRouter && !(force ?? false)) {
      const now = new Date();
      const term = now.getTime() - appCreateTime.getTime();
      if (!navigator.onLine || term < checkTime) {
        if (locale) {
          if (navigator.onLine) {
            location.href = path;
          }
        } else {
          appCreateTime = now;
          Debug("appRouterPush pushState href", path);
          window.history.pushState({}, "", path);
          window.dispatchEvent(new PopStateEvent("popstate"));
        }
      } else {
        Debug("appRouterPush refresh term", term);
        location.href = path;
      }
    } else {
      location.href = path;
      // router.push(url, options);
    }
  } else {
    router.push(url, options);
  }
};
export const AppDownloadBlank = (): boolean => {
  return false;
  // return Capacitor.isNativePlatform();
};

export async function shareBase64(ta: TransitionType, base64Data: string, fileName?: string, success?: Function, failed?: Function) {
  try {
    const cleaned = base64Data.replace(/^data:image\/\w+;base64,/, "");
    const saveName = (fileName ?? `photo_${Date.now()}`) + `.png`;
    // const ACapacitorPlugin
    //임시 저장
    const fileResult = await Filesystem.writeFile({
      path: saveName,
      data: cleaned,
      directory: Directory.Cache, // 임시 저장
    });
    Debug("임시 저장 완료:", JSON.stringify(fileResult));

    //이미지 공유
    await Share.share({
      title: ta("image_share_title"), //사진 저장
      text: ta("image_share_confirm"), //"갤러리에 저장하려면 선택하세요."
      dialogTitle: ta("image_share_text"), //"앱에서 사진 공유",
      url: fileResult.uri, // Filesystem에서 저장한 file:// 경로
    });

    Debug("저장 성공:", fileResult);
    if (success) {
      success(fileResult);
    }
  } catch (err) {
    Debug("저장 실패:", err);
    if (failed) {
      failed(err);
    }
  }
}

// export async function saveBase64ToGallery(
//   ta: TransitionType,
//   base64Data: string,
//   fileName?: string,
//   success?: Function,
//   failed?: Function,
// ) {
//   try {
//     // const checkAndroid = isAndroid();
//     // let saveAlbum: MediaAlbum | undefined;
//     // Debug("권한 체크 시작");
//     // if (checkAndroid) {
//     //   const check = await AlbumPermission.checkPermission();
//     //   Debug(JSON.stringify(check));
//     //   if (!check.granted) {
//     //     Debug("권한이 없습니다.");
//     //     if (failed) {
//     //       failed();
//     //     }
//     //     return;
//     //   }
//     //   const res = await Media.getAlbums();

//     //   const albumName = "Coffee Insite";

//     //   // albums 배열에 없으면 새 앨범 생성
//     //   if (!res.albums.find((a) => a.name === albumName)) {
//     //     await Media.createAlbum({ name: albumName });
//     //   }
//     //   // const { albums } = await Media.getAlbums();
//     //   const albumsPath = (await Media.getAlbumsPath()).path;
//     //   const { albums } = await Media.getAlbums();
//     //   // albums.forEach((value) => {
//     //   //   Debug(value);
//     //   // });
//     //   saveAlbum = albums.find((a) => a.name === albumName);
//     // }
//     // Debug("권한체크 완료");
//     // 앞부분 제거
//     const cleaned = base64Data.replace(/^data:image\/\w+;base64,/, "");
//     const saveName = (fileName ?? `photo_${Date.now()}`) + `.png`;
//     // const ACapacitorPlugin
//     //임시 저장
//     const fileResult = await Filesystem.writeFile({
//       path: saveName,
//       data: cleaned,
//       directory: Directory.Cache, // 임시 저장
//     });
//     Debug("임시 저장 완료:", JSON.stringify(fileResult));

//     // 2. 갤러리에 복사
//     // const result = await Media.savePhoto({
//     //   path: fileResult.uri,
//     //   fileName: saveName,
//     //   albumIdentifier: checkAndroid && saveAlbum ? saveAlbum.identifier : undefined, //saveAlbum?.identifier : undefined,
//     // });

//     await Share.share({
//       title: ta("image_save_title"), //사진 저장
//       text: ta("image_save_confirm"), //"갤러리에 저장하려면 선택하세요."
//       dialogTitle: ta("image_save_text"), //"앱에서 사진 공유",
//       url: fileResult.uri, // Filesystem에서 저장한 file:// 경로
//     });

//     Debug("저장 성공:", fileResult);
//     if (success) {
//       success(fileResult);
//     }
//   } catch (err) {
//     Debug("저장 실패:", err);
//     if (failed) {
//       failed(err);
//     }
//   }
// }
export const appInputScroll = (
  ref: RefObject<any>,
  open: boolean,
  checkScroll: boolean,
  useInput: boolean,
  scrollMargin?: string | number,
) => {
  if (open) {
    if (isNativePlatform) {
      if (ref.current) {
        const header = document.querySelector("div.mainTool > div > div.fixed ");
        const header_height = (header ? header.getBoundingClientRect().height : 0) + 16;
        const item = ref.current.nativeElement.closest("div.rt-DataListItem");
        const rect = item ? item.getBoundingClientRect() : undefined;
        const scrollMarginPx =
          typeof scrollMargin === "number"
            ? scrollMargin
            : typeof scrollMargin === "string"
              ? document.querySelector(scrollMargin)?.getBoundingClientRect().height
              : undefined;
        // const adsPannel = document.querySelector("body.App.Ads div.adsPannel");
        // const select_dropdown = document.querySelector("div.ant-select-dropdown:not(.ant-select-dropdown-hidden)");
        // const select_height = select_dropdown ? select_dropdown.getBoundingClientRect().height : 0;
        // const bottomMargin = adsPannel ? adsPannel.getBoundingClientRect().height : 20;
        // const windowHeight = window.innerHeight - bottomMargin;
        // const scrollHeight = document.body.scrollHeight;
        // const rectScrollDefault = window.scrollY - windowHeight + rect.top + rect.height;
        // const rectScrollTo = scrollHeight > rectScrollDefault + select_height ? rectScrollDefault + select_height : rectScrollDefault;
        // const rectScrollOver = scrollHeight > rectScrollDefault + select_height;
        const rectScrollLimit = window.scrollY + (rect ? rect.top : 0) - header_height - (scrollMarginPx ?? 0);
        window.scrollTo({ top: rectScrollLimit, behavior: "smooth" });
      }
      if (!useInput) {
      }
    }
    if (checkScroll) {
      disableScroll();
    }
  } else {
    enableScroll();
  }
};
export const fileSaved = (alertContext: AlertProps | undefined, ta: TransitionType) => {
  return () => {
    if (alertContext && alertContext.setProp) {
      alertContext?.setProp({
        open: true,
        title: ta("save"),
        description: ta("save_ok"),
        useCancel: false,
        useOk: true,
        okFunction: () => {},
      });
    } else {
      alert("saved");
    }
  };
};
export const fileSaveError = (alertContext: AlertProps | undefined, ta: TransitionType) => {
  return () => {
    if (alertContext && alertContext.setProp) {
      alertContext?.setProp({
        open: true,
        title: ta("save"),
        description: ta("error_text"),
        useCancel: false,
        useOk: true,
        okFunction: () => {},
      });
    }
  };
};
export type AppPostDataType = {
  dataType: string;
  key: string | Record<string, string>;
  value: string;
  valueType?: string | Record<string, string>;
};
export const AppPostData = (postData: AppPostDataType) => {
  if (Capacitor.isNativePlatform()) {
    const platform = Capacitor.getPlatform();
    const anyWindow = window as any;
    const checkPlatform = platform === "ios";
    const checkData = checkPlatform ? postData : JSON.stringify(postData);
    const AppPostData = checkPlatform ? anyWindow?.webkit?.messageHandlers?.AppPostData : anyWindow.AppPostData;
    if (AppPostData && AppPostData.postMessage) {
      AppPostData.postMessage(checkData);
    } else {
      console.log("AppPostData is null");
    }
  }
};
